import { PlusIcon } from "@components/icons";

export function CustomAddCard({ firstTitleLine, secondTitleLine, ...props }) {
    return (
        <div className="h-64 w-44 cursor-pointer rounded-2xl border-1 border-zinc-300 bg-transparent p-4 hover:bg-transparent/5" {...props}>
            <span className="w-full text-center text-zinc-400">
                <p>{firstTitleLine}</p>
                <p>{secondTitleLine}</p>
            </span>
            <PlusIcon className="mx-auto mt-12 size-8 stroke-zinc-400" />
        </div>
    );
}